// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_CardOverlay.scss
// module id = 606
// module chunks = 49 88